import React, { useState } from 'react';
import { Row, Col, Skeleton, Divider } from 'antd';
import {
  MainWrapper,
  SocialAccountCard,
  AdWidgetDrawer,
  AdWidgetMedia,
} from '..';
import { getLastSubId } from '../../utils/commonUtils';
import Wrapper from './style';

const Index = (props) => {
  const {
    ad,
    isLoading,
    userSocMed,
    adIntegrations,
    padding = '24px',
    styleMainWrapper = {},
    style = {},
    adsAccountID,
  } = props;
  const [showAdDetail, setShowAdDetail] = useState(false);
  const adCreativeData =
    adIntegrations?.socmed_ad_local?.data?.creative?.data || {};
  const objectStorySpec = adCreativeData?.ad_creative?.object_story_spec || {};
  const linkData = objectStorySpec?.link_data || {};

  return (
    <>
      <AdWidgetDrawer
        ad={ad}
        showAdDetail={showAdDetail}
        setShowAdDetail={setShowAdDetail}
      />
      <Wrapper padding={padding} style={style}>
        <MainWrapper
          className="component_ad_widget_wrapper"
          style={styleMainWrapper}
        >
          {isLoading && <Skeleton />}
          {!isLoading && (
            <>
              <div className="font-paragraph_medium black1">Ad</div>
              <Row gutter={[16, 16]}>
                <Col span={24}>
                  <AdWidgetMedia
                    accountType={adIntegrations?.user_socmed?.type}
                    accountId={adIntegrations?.user_socmed_id}
                    lineItemIds={adIntegrations?.socmed_adset_id}
                    linkData={linkData}
                    documents={adIntegrations?.documents}
                  />
                </Col>
                <Col span={24}>
                  <Row gutter={4}>
                    <Col span={24} className="font-paragraph_medium black3">
                      Ad Name
                    </Col>
                    <Col span={24}>
                      <Row>
                        <Col span={24} className="font-paragraph black1">
                          {ad?.name}
                        </Col>
                        <Col span={24} className="font-paragraph black3">
                          {getLastSubId(ad?.id)}
                        </Col>
                      </Row>
                    </Col>
                  </Row>
                </Col>
                <Col
                  aria-hidden="true"
                  span={24}
                  style={{ cursor: 'pointer' }}
                  className="font-paragraph_medium orange1"
                  onClick={() => {
                    setShowAdDetail(true);
                  }}
                >
                  SEE MORE
                </Col>
              </Row>
              <Divider />
              <SocialAccountCard
                username={userSocMed?.username}
                url={userSocMed?.url}
                type={userSocMed?.type}
                showAvatar={false}
                adsAccountID={adsAccountID}
              />
            </>
          )}
        </MainWrapper>
      </Wrapper>
    </>
  );
};

export default Index;
